import { render, staticRenderFns } from "./ForgotePassword.vue?vue&type=template&id=3589b28a"
import script from "./ForgotePassword.vue?vue&type=script&lang=js"
export * from "./ForgotePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports